import saveAs from 'file-saver';
import type { FileResponse } from '@shared/api/models';

export class FileUtils {
  static downloadFile = (file: FileResponse, defaultFileName = 'download') => {
    const data = new Blob([file.data]);

    const reFileName = new RegExp('filename=(?<fileName>.+?)(?<fileType>\\.[a-zA-Z0-9]+);').exec(file.contentDisposition);
    const fileName = reFileName?.groups?.fileName?.trim() ?? defaultFileName;
    const fileType = reFileName?.groups?.fileType?.trim() ?? this.getFileExtensions(file);
    const fullFileName = `${fileName}.${fileType}`;

    saveAs(data, fullFileName);
  };

  static getFileExtensions = (file: FileResponse) => {
    if (!file.contentType) return 'txt';
    else if (file.contentType == 'application/pdf') return 'pdf';
    else if (file.contentType == 'application/vnd.ms-excel') return 'xls';
    else if (file.contentType == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return 'xlsx';
    if (file.contentType === 'image/jpeg') return 'jpeg';
    if (file.contentType === 'image/pjpeg') return 'pjpeg';
    if (file.contentType === 'image/jfif') return 'jfif';
    if (file.contentType === 'image/png') return 'png';
    if (file.contentType === 'image/gif') return 'gif';
    if (file.contentType === 'image/bmp') return 'bmp';
    if (file.contentType === 'image/webp') return 'webp';
    if (file.contentType === 'image/svg+xml') return 'svg';
    if (file.contentType === 'image/svgz') return 'svgz';
    if (file.contentType === 'image/ico') return 'ico';
    if (file.contentType === 'image/xbm') return 'xbm';
    if (file.contentType === 'image/dib') return 'dib';
    if (file.contentType === 'image/pjp') return 'pjp';
    if (file.contentType === 'image/tiff') return 'tiff';
    if (file.contentType === 'image/tif') return 'tif';
    if (file.contentType === 'image/avif') return 'avif';
    if (file.contentType === 'image/apng') return 'apng';
    return 'txt';
  };
}
